export const AmplifyConfig = {
  Auth: {
    userPoolId: 'eu-central-1_R2JK7eeON',
    userPoolWebClientId: 'b5cd93ruqr8i1ruemiv5h80e1',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    identityPoolId: 'eu-central-1:9ef57fa7-7d9a-45a9-9dea-40f20d94d583'
  }
};
